import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Services from './pages/Services';
import ServiceQuoteForm from './components/ServiceQuoteForm';
import BookingForm from './components/BookingForm';
import Contact from './pages/Contact';
import About from './pages/About';
import CleaningProcess from './pages/CleaningProcess';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop.js';
import { AdminProvider } from './context/AdminContext.js';
import ProtectedRoute from './pages/admin/ProtectedRoute.js';
import AdminLogin from './pages/admin/AdminLogin.js';
import AdminLayout from './pages/admin/AdminLayout.js';
import DashboardPage from './pages/admin/DashboardPage.js';
import QuoteLeadsPage from './pages/admin/QuoteLeadsPage.js';
import ContactMessagesPage from './pages/admin/ContactMessagesPage.js';
import BookingsPage from './pages/admin/BookingsPage.js';
import AdminsPage from './pages/admin/AdminsPage.js';
import SecuritySettingsPage from './pages/admin/SecuritySettingsPage.js';

const PublicLayout = () => (
  <>
    <Header />
    <Outlet />
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/get-quote" element={<ServiceQuoteForm />} />
          <Route path="/book" element={<BookingForm seoEnabled />} />

          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/cleaning-process" element={<CleaningProcess />} />
        </Route>

        {/* Admin panel — no public Header/Footer, its own auth-gated layout instead */}
        <Route
          path="/admin"
          element={
            <AdminProvider>
              <Outlet />
            </AdminProvider>
          }
        >
          <Route path="login" element={<AdminLogin />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<AdminLayout />}>
              <Route index element={<Navigate to="quote-leads" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="quote-leads" element={<QuoteLeadsPage />} />
              <Route path="contact-messages" element={<ContactMessagesPage />} />
              <Route path="bookings" element={<BookingsPage />} />
              <Route path="admins" element={<AdminsPage />} />
              <Route path="security" element={<SecuritySettingsPage />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
